var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92533 6.93332C8.13867 6.92266 8.34133 7.06132 8.416 7.27466L11.8293 16.1387C11.9253 16.4053 11.7973 16.7147 11.52 16.8213C11.2427 16.9173 10.9333 16.7893 10.8267 16.512L9.696 13.6H6.09067L4.97067 16.5013C4.864 16.768 4.55467 16.9067 4.27734 16.8C4 16.6933 3.86134 16.384 3.968 16.1067L7.37067 7.22132C7.44533 7.00799 7.63733 6.86932 7.86133 6.86932L7.92533 6.93332ZM7.92533 8.94932L9.376 12.7147H6.47467L7.91467 8.93866L7.92533 8.94932ZM15.6053 9.54666C13.8453 9.54666 12.5227 11.1147 12.5227 13.1733C12.5227 15.328 13.952 16.8 15.5947 16.8C16.4693 16.8 17.376 16.4267 17.9947 15.7333V16.2667C17.9947 16.5227 18.208 16.7467 18.4747 16.7467C18.7307 16.7467 18.9547 16.5227 18.9547 16.2667V10.0693C18.9547 9.80266 18.7307 9.58932 18.4747 9.58932C18.208 9.58932 17.9947 9.80266 17.9947 10.0693V10.6027C17.408 9.93066 16.5333 9.51466 15.584 9.51466L15.6053 9.54666ZM18.0053 14.4427V11.776C17.5787 10.9973 16.704 10.4427 15.7973 10.4427C14.752 10.4427 13.6 11.4027 13.6 13.1627C13.6 14.8053 14.6347 15.8827 15.7867 15.8827C16.7253 15.8827 17.5787 15.168 17.984 14.4213L18.0053 14.4427Z",
    fill: "#9DA6AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/text-icon.36e0963daf071622f41ee6b02a3d2a25.svg";
export { ForwardRef as ReactComponent };